import FavoriteIcon from '@mui/icons-material/Favorite';
import PsychologyIcon from '@mui/icons-material/Psychology';
import QuizIcon from '@mui/icons-material/Quiz';
import StarsIcon from '@mui/icons-material/Stars';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';

interface Props {
  contactName: string | undefined;
  assessment: Assessment | undefined;
}

const ContactPersonality: React.FC<Props> = ({ contactName, assessment }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const personalityTypes: { name: string; content: string[] | undefined }[] = [
    { name: t('contactCharacteristics', { contactName: contactName }), content: assessment?.instructions?.descriptions?.shortdescription?.split(',') },
    { name: t('definesContact', { contactName: contactName }), content: assessment?.instructions?.descriptions?.listdescription },
    { name: t('importantToContact', { contactName: contactName }), content: assessment?.instructions?.descriptions?.importantdescription },
    { name: t('answerContactQuestions', { contactName: contactName }), content: assessment?.instructions?.descriptions?.descriptionquestions },
  ];

  return (
    <Stack gap={1}>
      {personalityTypes.map((item, idx1) => (
        <div key={idx1} className={classes.card}>
          <>
            <Stack className={classes.listTitle} direction={'row'} alignItems={'center'} gap={1.5} mb={'8px'}>
              {idx1 === 0 ? (
                <PsychologyIcon className={classes.icon} />
              ) : idx1 === 1 ? (
                <FavoriteIcon className={classes.icon} />
              ) : idx1 === 2 ? (
                <StarsIcon className={classes.icon} />
              ) : idx1 === 3 ? (
                <QuizIcon className={classes.icon} />
              ) : null}
              <Typography className={classes.text}>{item.name}</Typography>
            </Stack>
            {item.content?.map((text, idx2) => (
              <Stack className={classes.listItem} key={idx2} direction={'row'} alignItems={'center'} gap={1.5}>
                <Typography className={classes.listItemText}>{text}</Typography>
              </Stack>
            ))}
          </>
        </div>
      ))}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    width: '100%',
    background: '#FFF',
    padding: '8px 16px',
    borderRadius: '8px',
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
  },
  icon: {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.primary.main,
  },
  listTitle: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    marginBottom: '8px',
    paddingBottom: '8px',
  },
  listItem: {
    borderBottom: `1px solid ${theme.palette.greys.light}`,
    marginBottom: '8px',
    paddingBottom: '8px',
    '&:last-of-type': {
      borderBottom: 'none',
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  listItemText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
  },
}));

export default ContactPersonality;
